<div
  id="chat-window-container"
  class="row row-cols-1 row-cols-lg-2 d-flex overflow-hidden pb-lg-2"
  [ngStyle]="{ height: containerHeight }"
  (click)="closeOpenedItemsOutsideClick()"
>
  @if (
    (!selectedChatConversation?.id && !gtNotificationsList?.length) || largeView
  ) {
    <div
      class="col col-lg-4 border-end bg-body-tertiary pt-1 mh-100 overflow-scroll pb-3"
    >
      @if (!showArchivedList && conversationListData?.length) {
        <div class="d-flex gap-1 align-items-center">
          <div class="flex-grow-1">
            <div class="input-group my-2">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Search Chats"
                  (input)="onChatSearchLookup()"
                  [(ngModel)]="chatFilterValue"
                />
                <label>Search Chats</label>
              </div>
              @if (chatFilterValue) {
                <span class="input-group-text" (click)="chatFilterValue = ''">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
          @if (
            (isAdmin || isDispatchUser) &&
            !offlineMode &&
            addGroupOptionAvailable
          ) {
            <div>
              <button
                class="btn d-flex align-items-center btn-lg border-0"
                (click)="openTemplate(modifyGroupTemplate, 'modifyGroup')"
              >
                <span><i class="fa-solid fa-people-group fs-4"></i></span>
              </button>
            </div>
          }
        </div>
      }
      @if (hasArchivedChats && !chatFilterValue) {
        <div
          (click)="showArchivedList = !showArchivedList"
          class="p-2 mb-1 hover d-flex align-items-center opacity-75"
          role="button"
        >
          <div class="flex-grow-1 d-flex align-items-center">
            @if (showArchivedList) {
              <span
                ><i
                  class="fa-solid fa-arrow-left md-font-size text-secondary me-2"
                ></i
              ></span>
            } @else {
              <span>
                <i class="fa-solid fa-box-archive text-secondary me-3"></i>
              </span>
            }
            <span> Archived </span>
          </div>
          @if (unreadArchivedConversationCount) {
            <div class="text-danger fw-semibold">
              {{ unreadArchivedConversationCount }}
            </div>
          }
        </div>
      }
      @if (chatFilterValue && chatSearchLookup) {
        <div class="alert alert-secondary opacity-75 my-1">
          <div>
            Searching
            <span class="spinner-border spinner-border-sm" role="status"></span>
          </div>
        </div>
      }
      @if (gtNotificationCount && !chatFilterValue) {
        <div
          class="d-flex align-items-center rounded p-2 mb-1 border bg-body user-card-hover border-warning"
          (click)="getNotifications(true); selectedChatConversation = null"
        >
          <div>
            <div class="profile-image-circle">
              {{ "Guard Tracker" | misc: "getInitials" }}
            </div>
          </div>
          <div class="flex-grow-1 ms-2">
            <div
              class="d-flex align-items-center gap-3 justify-content-between"
            >
              <div class="d-flex">
                <div class="fw-semibold">System Notifications</div>

                <div class="badge bg-danger text-white small ms-2">
                  {{ gtNotificationCount }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--in app notification list -->
      }
      @for (
        chat of chatFilterValue ? filteredChatListData : conversationListData;
        track chat
      ) {
        <div (click)="resetPagesAndGetData(chat)">
          @if (
            chatFilterValue
              ? true
              : showArchivedList
                ? chat?.archived_id
                : !chat?.archived_id
          ) {
            <div
              class="d-flex align-items-center rounded p-2 mb-1 border bg-body user-card-hover"
              [class.opacity-75]="
                !chat?.signed_in && chat?.chat_type == 'individual_chat'
              "
            >
              <div>
                @if (chat?.chat_type == "individual_chat") {
                  <div
                    class="profile-image-circle"
                    [gtappPopover]="userDetailPopoverTemplate"
                    [popoverData]="{ userId: chat?.id }"
                  >
                    @if (chat?.profile_image_url) {
                      <img
                        [alt]="chat?.user_name | misc: 'getInitials'"
                        class="cursor-pointer"
                        [src]="chat?.profile_image_url"
                      />
                    } @else {
                      {{ chat?.user_name | misc: "getInitials" }}
                    }
                  </div>
                } @else {
                  <div class="profile-image-circle">
                    @if (chat?.profile_image_url) {
                      <img
                        [alt]="chat?.user_name | misc: 'getInitials'"
                        class="cursor-pointer"
                        [src]="chat?.profile_image_url"
                      />
                    } @else {
                      {{ chat?.user_name | misc: "getInitials" }}
                    }
                  </div>
                }
              </div>
              <div class="flex-grow-1 ms-2">
                <div
                  class="d-flex align-items-center gap-3 justify-content-between"
                >
                  <div class="d-flex">
                    <div [ngClass]="chat?.unread_count ? 'fw-semibold' : ''">
                      {{ chat?.user_name }}
                    </div>
                    @if (chat?.unread_count) {
                      <div class="badge bg-danger text-white small ms-2">
                        {{ chat?.unread_count }}
                      </div>
                    }
                  </div>
                  @if (chat?.signed_in || chat?.chat_type == "group_chat") {
                    <div
                      class="small-font border border-2 px-2 py-0 rounded text-center bg-white fw-semibold"
                      [ngClass]="
                        chat?.chat_type == 'group_chat'
                          ? 'border-secondary-subtle text-secondary'
                          : 'border-success text-success'
                      "
                    >
                      {{
                        chat?.chat_type == "group_chat" ? "Group" : "Signed In"
                      }}
                    </div>
                  }
                </div>
                @if (chatFilterValue) {
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      @for (
                        part of chat?.message
                          | misc: "chatSearchTerm" : chatFilterValue;
                        track part
                      ) {
                        @if (part?.higlighted) {
                          <span class="text-success">
                            {{ part?.text }}
                          </span>
                        } @else {
                          {{ part?.text }}
                        }
                      }
                    </div>
                    <div class="text-end text-secondary small-font">
                      {{
                        chat?.created_at | misc: "userReadableDateTimeFormat"
                      }}
                    </div>
                  </div>
                } @else {
                  @if (chat?.last_message) {
                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex flex-grow-1 small"
                        [ngClass]="chat?.unread_count ? 'fw-semibold' : ''"
                      >
                        <div>
                          @if (chat?.sent_by) {
                            <span>{{ chat?.sent_by }}: </span>
                          }
                          {{ chat?.last_message | misc: "sliceWord" : 40 }}
                        </div>
                        @if (
                          chat?.sent_at &&
                          !chatFilterValue &&
                          chat?.last_message
                        ) {
                          <div
                            class="ms-auto text-end text-secondary small-font pt-1"
                          >
                            {{
                              chat?.sent_at | misc: "userReadableDateTimeFormat"
                            }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (selectedChatConversation?.id) {
    <div class="chat-container col col-lg-8 p-0">
      <div
        class="d-flex align-items-center gap-3 p-2 pt-3 border-bottom bg-body-tertiary"
      >
        @if (!largeView) {
          <div>
            <span (click)="goBack()"
              ><i class="fa-solid fa-arrow-left md-font-size text-secondary"></i
            ></span>
          </div>
        }
        @if (selectedChatConversation?.chat_type == "individual_chat") {
          <div
            class="profile-image-circle"
            [gtappPopover]="userDetailPopoverTemplate"
            [popoverData]="{ userId: selectedChatConversation?.id }"
          >
            @if (selectedChatConversation?.profile_image_url) {
              <img
                [alt]="
                  selectedChatConversation?.user_name | misc: 'getInitials'
                "
                class="cursor-pointer"
                [src]="selectedChatConversation?.profile_image_url"
              />
            } @else {
              {{ selectedChatConversation?.user_name | misc: "getInitials" }}
            }
          </div>
        } @else {
          <div class="profile-image-circle">
            @if (selectedChatConversation?.profile_image_url) {
              <img
                [alt]="
                  selectedChatConversation?.user_name | misc: 'getInitials'
                "
                class="cursor-pointer"
                [src]="selectedChatConversation?.profile_image_url"
              />
            } @else {
              {{ selectedChatConversation?.user_name | misc: "getInitials" }}
            }
          </div>
        }
        <div>
          <div class="d-flex align-items-center gap-3">
            <div
              [class.link-edit]="
                selectedChatConversation?.chat_type == 'group_chat' &&
                !offlineMode
              "
              (click)="
                selectedChatConversation?.chat_type == 'group_chat' &&
                !offlineMode
                  ? openTemplate(
                      modifyGroupTemplate,
                      'modifyGroup',
                      selectedChatConversation
                    )
                  : null
              "
            >
              {{ selectedChatConversation?.user_name }}
            </div>
          </div>

          @if (selectedChatConversation?.members?.length) {
            <div class="small text-body-secondary">
              {{
                selectedChatConversation?.members?.join(", ")
                  | misc: "sliceWord" : (largeView ? 80 : 40)
              }}
            </div>
          }
          @if (isInLiveDraft && liveDraftBy?.id) {
            <div class="small-font text-success fw-semibold">
              {{ liveDraftBy?.user_name }} is typing....
            </div>
          } @else {
            @if (
              selectedChatConversation?.last_seen &&
              selectedChatConversation?.signed_in &&
              !offlineMode
            ) {
              <div class="small-font text-body-secondary">
                Last seen
                {{
                  selectedChatConversation?.last_seen
                    | misc: "formatLastSeenDateTime"
                }}
              </div>
            }
          }
        </div>
        @if (!offlineMode) {
          <div class="ml-auto">
            <div
              class="ms-2"
              (click)="
                showChatOptions = !showChatOptions;
                $event.stopImmediatePropagation()
              "
            >
              <i
                class="fa-solid fa-ellipsis-vertical me-3 text-secondary fs-4"
              ></i>
              @if (showChatOptions) {
                <div
                  class="shadow chat-options-dropdown border p-3 bg-body d-flex flex-column gap-4 small"
                >
                  <div
                    class="w-100 cursor-pointer"
                    (click)="
                      manageConversation(
                        selectedChatConversation?.archived_id
                          ? 'unarchive'
                          : 'archive'
                      );
                      closeOpenedItemsOutsideClick();
                      $event.stopImmediatePropagation()
                    "
                  >
                    {{
                      selectedChatConversation?.archived_id
                        ? "Unarchive"
                        : "Archive"
                    }}
                  </div>
                  @if (
                    selectedChatConversation?.chat_type == "group_chat" &&
                    !offlineMode
                  ) {
                    <div
                      class="w-100 cursor-pointer"
                      (click)="
                        selectedChatConversation?.chat_type == 'group_chat' &&
                        !offlineMode
                          ? openTemplate(
                              modifyGroupTemplate,
                              'modifyGroup',
                              selectedChatConversation
                            )
                          : null
                      "
                    >
                      Group Information
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div
        (scroll)="onWindowScroll($event)"
        #content
        [ngClass]="
          largeView ||
          messageList[0]?.id != chatFirstLastIds?.first_id ||
          messageList[messageList?.length - 1]?.id !=
            chatFirstLastIds?.last_id ||
          messageList?.length > 10
            ? 'chat-content'
            : 'chat-content-small'
        "
      >
        @if (
          messageList[0]?.id != chatFirstLastIds?.first_id &&
          !offlineMode &&
          !messageList[0]?.cachedItem
        ) {
          @if (scrollTimeout) {
            <div class="alert alert-primary my-3">
              <div class="fw-bold">
                Fetching Data from Server
                <div class="spinner-grow float-end" role="status"></div>
              </div>
            </div>
          } @else {
            <div class="small-font text-center text-secondary my-2">
              Scroll up for older messages
            </div>
          }
        }

        @for (
          message of messageList;
          track message?.id;
          let l = $last;
          let index = $index
        ) {
          @if (index === anchorIndex) {
            <!-- used for iphones on scrolling up-->
            <div #anchor></div>
          }
          @if (
            index === 0 ||
            (messageList[index - 1].created_at | misc: "eventDateGrouping") !==
              (message?.created_at | misc: "eventDateGrouping")
          ) {
            <!--date change/grouping at the center of chat -->
            <div class="p-2 text-center fw-semibold text-secondary small">
              {{ message?.created_at | misc: "eventDateGrouping" }}
            </div>
          }
          <div
            class="mt-1 d-flex"
            [ngClass]="{
              'sender d-inline': message?.sender?.id == subscriberUserId,
              'rounded-3': selectedMessageIndex === index,
            }"
          >
            <div
              (dblclick)="selectedMessage = message"
              [ngClass]="
                message?.sender?.id == subscriberUserId
                  ? 'sender-container'
                  : 'receiver-container'
              "
              (click)="
                onChatMessageClick(l ? 'lastItem' : '', index);
                $event.stopImmediatePropagation()
              "
            >
              <div class="d-inline gap-2">
                @if (
                  selectedChatConversation?.chat_type == "group_chat" &&
                  message?.sender?.id !== subscriberUserId
                ) {
                  <div class="profile-image-circle">
                    @if (
                      userConvDetailedDataDict?.[message?.sender?.id]
                        ?.profile_image_url
                    ) {
                      <img
                        alt="Profile Image"
                        class="cursor-pointer"
                        [src]="
                          userConvDetailedDataDict?.[message?.sender?.id]
                            ?.profile_image_url
                        "
                        (click)="
                          onProfileImageClick(
                            userConvDetailedDataDict?.[message?.sender?.id]
                              ?.profile_image_url
                          );
                          $event.stopImmediatePropagation()
                        "
                      />
                    } @else {
                      {{ message?.sender?.user_name | misc: "getInitials" }}
                    }
                  </div>
                }
                <div
                  class="d-flex align-items-center"
                  [ngClass]="
                    message?.sender?.id == subscriberUserId
                      ? 'flex-row-reverse'
                      : ''
                  "
                >
                  <div
                    [ngClass]="
                      message?.sender?.id == subscriberUserId
                        ? 'sender-card'
                        : 'receiver-card'
                    "
                    [id]="'chat-' + message?.id"
                  >
                    <div class="d-flex mb-1">
                      @if (
                        message?.sender?.user_name &&
                        message?.sender?.id !== subscriberUserId &&
                        selectedChatConversation?.chat_type == "group_chat"
                      ) {
                        <div
                          class="fw-semibold px-1 ms-2 small rounded"
                          [ngStyle]="
                            groupMemberColorAssign?.[message?.sender?.id]
                          "
                        >
                          {{ message?.sender?.user_name }}
                        </div>
                      }
                      @if (message?.edited_at || message?.event_action == 2) {
                        <!--edited message indicator-->
                        <span class="small rounded-2 px-1 ms-auto text-light">
                          @if (message?.edited_at) {
                            <span
                              [ngClass]="
                                message?.sender?.id == subscriberUserId
                                  ? 'opacity-75'
                                  : 'text-body opacity-50'
                              "
                            >
                              Edited
                              {{ message?.edited_at | customDate: "HH:mm" }}
                            </span>
                          }
                          @if (message?.event_action == 2) {
                            <span class="opacity-75" title="Forwarded">
                              <!--forwarded message indicator-->
                              <i class="fa-solid fa-share"></i>
                            </span>
                          }
                        </span>
                      }
                    </div>
                    @if (message?.reply?.id) {
                      <!--replied message details-->
                      <div
                        class="small-font bg-secondary-subtle rounded-2 p-2 mb-2 border-start border-5 border-dark"
                      >
                        <div class="text-secondary">
                          {{ message?.reply?.sender?.user_name }}
                          |
                          {{
                            message?.reply?.created_at
                              | customDate: "d MMM y HH:mm"
                          }}
                        </div>
                        <div class="text-dark gt-multi-line">
                          {{ message?.reply?.message | misc: "sliceWord" : 40 }}
                        </div>
                      </div>
                    }
                    @if (message?.job?.id || message?.patrol_route?.id) {
                      <!-- selected job/patrol info-->
                      <div
                        class="small-font bg-secondary-subtle rounded-2 p-2 mb-2 border-start border-5 border-dark text-dark"
                        (click)="routeToJob(message)"
                      >
                        <i class="fa-solid fa-link me-2"></i>
                        <span
                          >{{
                            message?.job?.site_name ||
                              message?.patrol_route?.site_name
                          }}
                          [{{
                            message?.job?.job_id
                              ? message?.job?.job_id
                              : "Patrol"
                          }}]
                        </span>
                      </div>
                    }

                    @if (message?.file) {
                      <ng-template
                        *ngTemplateOutlet="
                          messageFileTempalte;
                          context: { value: message }
                        "
                      ></ng-template>
                    }

                    <div class="p-2 gt-multi-line mb-3">
                      @for (
                        part of message?.message | misc: "generateLinks";
                        track part
                      ) {
                        @if (part?.url) {
                          <a
                            [href]="part?.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ part?.url }}</a
                          >
                        } @else {
                          {{ part }}
                        }
                      }
                    </div>

                    @if ([".mp3"].includes(message?.file_extension)) {
                      @if (message?.message) {
                        <div class="text-end small">
                          Transcribed <i class="fa-solid fa-microphone"></i>
                          <i class="fa-solid fa-arrow-right-long"></i>
                          <i class="fa-solid fa-t"></i>
                        </div>
                      } @else if (
                        message?.additional_info &&
                        "audio_transcription_complete" in
                          message?.additional_info
                      ) {
                        @if (
                          message?.additional_info?.audio_transcription_complete
                        ) {
                          <div class="text-end small">No speech detected</div>
                        } @else {
                          <div
                            class="justify-content-end d-flex align-items-center gap-2"
                          >
                            <div>Processing Audio</div>
                            <div
                              class="spinner-border text-light spinner-border-sm"
                              role="status"
                            ></div>
                          </div>
                        }
                      }
                    }
                    <div
                      class="d-flex timestamp justify-content-end gap-1 opacity-75"
                      [ngClass]="
                        message?.sender?.id == subscriberUserId
                          ? 'text-white'
                          : 'text-dark'
                      "
                    >
                      @if (
                        message?.receiver?.id == subscriberUserId ||
                        (selectedChatConversation?.chat_type == "group_chat" &&
                          selectedChatConversation?.members?.length)
                      ) {
                        {{ message?.created_at | customDate: "HH:mm" }}
                        @if (
                          message?.sender?.id == subscriberUserId &&
                          (selectedChatConversation?.otherMemberIds
                            | misc: "chatReadMembers" : message?.read_json) ==
                            selectedChatConversation?.otherMemberIds?.length
                        ) {
                          <span>
                            <i class="fa-solid fa-check-double text-white"></i>
                          </span>
                        }
                      }
                      @if (
                        message?.sender?.id == subscriberUserId &&
                        message?.read_json?.[selectedChatConversation?.id] &&
                        selectedChatConversation?.chat_type != "group_chat"
                      ) {
                        {{
                          message?.read_json?.[selectedChatConversation?.id]
                            | customDate: "HH:mm"
                        }}
                        <span>
                          <i class="fa-solid fa-check-double text-white"></i>
                        </span>
                      }
                      @if (
                        message?.sender?.id == subscriberUserId &&
                        message?.cachedItem &&
                        (message?.file_extension != ".mp3" || message?.message)
                      ) {
                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="This message has not yet been uploaded to the server."
                        >
                          <div
                            class="spinner-border text-light spinner-border-sm"
                            role="status"
                          ></div>
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
              @if (selectedMessageIndex === index) {
                <div
                  class="border rounded-4 p-2 bg-secondary-subtle shadow message-options align-items-center gap-4 opacity-75 d-flex"
                >
                  <!-- reply select icon/ double click also avaialbe-->
                  <span
                    (click)="
                      selectedMessage = message;
                      closeOpenedItemsOutsideClick();
                      $event.stopImmediatePropagation()
                    "
                    ><i
                      class="fa-solid fa-reply text-secondary fa-2x"
                      title="Reply"
                    ></i
                  ></span>
                  <span
                    (click)="
                      closeOpenedItemsOutsideClick();
                      openTemplate(
                        forwardMessageTemplateRef,
                        'forwardComment',
                        message
                      );
                      $event.stopImmediatePropagation()
                    "
                  >
                    <i
                      class="fa-solid fa-share text-primary fa-2x"
                      title="Forward"
                    ></i
                  ></span>
                  @if (message?.message) {
                    <span
                      (click)="
                        closeOpenedItemsOutsideClick();
                        copyMessageToClipBoard(message);
                        $event.stopImmediatePropagation()
                      "
                    >
                      <i
                        class="fa-solid fa-copy text-secondary fa-2x"
                        title="Copy"
                      ></i
                    ></span>
                  }
                  @if (message?.sender?.id == subscriberUserId) {
                    <span
                      (click)="
                        closeOpenedItemsOutsideClick();
                        openTemplate(
                          editMessageTemplateRef,
                          'editComment',
                          message
                        );
                        $event.stopImmediatePropagation()
                      "
                      ><i
                        title="Edit"
                        class="fa-solid fa-pen-to-square text-primary fa-2x"
                      ></i
                    ></span>
                    <span
                      (click)="
                        closeOpenedItemsOutsideClick();
                        deleteChatMessage(message);
                        $event.stopImmediatePropagation()
                      "
                      ><i
                        title="Delete"
                        class="fa-solid fa-trash text-danger fa-2x"
                      ></i
                    ></span>
                  }
                </div>
              }
            </div>
          </div>
          @if (l) {
            <div id="lastItem" class="pb-5"></div>
          }
        }

        @if (
          messageList[messageList?.length - 1]?.id !=
            chatFirstLastIds?.last_id &&
          !offlineMode &&
          !messageList[messageList?.length - 1]?.cachedItem
        ) {
          @if (scrollTimeout) {
            <div class="alert alert-primary my-3">
              <div class="fw-bold">
                Fetching Data from Server
                <div class="spinner-grow float-end" role="status"></div>
              </div>
            </div>
          } @else {
            <div class="small-font text-center text-secondary my-2">
              Scroll down for newer messages
            </div>
          }
        }
      </div>
      @if (!offlineMode) {
        <div class="p-1 pb-2 rounded">
          <div class="d-flex gap-3">
            @if (selectedMessage) {
              <div
                class="bg-secondary-subtle rounded-2 p-2 mb-2 border-start border-5 border-info text-dark d-flex gap-3 justify-content-between w-100"
              >
                <div>
                  <div class="small-font text-secondary">
                    {{ selectedMessage?.sender?.user_name }} |
                    {{ selectedMessage?.created_at | customDate: "HH:mm" }}
                  </div>
                  <div>
                    {{ selectedMessage?.message | misc: "sliceWord" : 60 }}
                  </div>
                  <div>
                    @if (selectedMessage?.file) {
                      <ng-template
                        *ngTemplateOutlet="
                          messageFileTempalte;
                          context: { value: selectedMessage }
                        "
                      ></ng-template>
                    }
                  </div>
                </div>
                <div (click)="selectedMessage = null">
                  <i
                    class="fa-solid text-secondary fw-semibold fa-xmark md-font-size"
                  ></i>
                </div>
              </div>
            }
            @if (handOverLogData?.id) {
              <div
                class="small-font border border-info rounded-3 py-2 px-1 d-flex align-items-center gap-3 m-0 mb-1"
              >
                <i class="fa-solid fa-reply text-secondary fw-semibold"></i>
                <span>{{
                  handOverLogData?.description | misc: "sliceWord" : 40
                }}</span>
                <span class="float-end" (click)="handOverLogData = null"
                  ><i
                    class="fa-solid text-secondary fw-semibold fa-xmark md-font-size"
                  ></i
                ></span>
              </div>
            }
            @if (selectedJob?.event_id) {
              <div
                class="small-font border border-info rounded-3 py-2 px-1 d-flex align-items-center gap-3 m-0 mb-1"
              >
                <i class="fa-solid fa-reply text-secondary fw-semibold"></i>
                <span
                  >{{ selectedJob?.site_name }} [{{
                    selectedJob?.job_id ? selectedJob?.job_id : "Patrol"
                  }}]
                </span>
                <span class="float-end" (click)="selectedJob = null"
                  ><i
                    class="fa-solid text-secondary fw-semibold fa-xmark md-font-size"
                  ></i
                ></span>
              </div>
            }
          </div>
          <div class="float-end">
            @if (websocketMessageReceivedCount > 0) {
              <div
                (click)="scrollToBottom(); websocketMessageReceivedCount = 0"
                class="scroll-to-bottom"
              >
                <span class="badge bg-danger text-end">
                  {{ websocketMessageReceivedCount }}
                </span>
                <span>
                  <i class="fa-solid fa-angles-down fa-2x text-white"> </i>
                </span>
              </div>
            }
          </div>
          <div
            class="d-flex align-items-center gap-3 px-2 px-lg-3"
            id="chatContainer"
          >
            @if (showFabActions) {
              <span (click)="openJobSearchTemplate(jobSearchTemplate)">
                <i class="fa-solid fa-link fa-2x"></i>
              </span>
              <span (click)="openCamPopupDialog()">
                <i class="fa-solid fa-file-image fa-2x"></i>
              </span>
            } @else {
              <span (click)="showHideFAB()">
                <i class="fa-solid fa-paperclip fa-2x"></i>
              </span>
            }

            <div class="flex-grow-1">
              <textarea
                class="form-control md-font-size"
                type="text"
                [(ngModel)]="chatMessage"
                (input)="onMessageInput()"
                id="chatInputField"
                (focus)="showFabActions = false; scrollToBottom(true)"
                (keyup.enter)="
                  chatMessage.trim() && largeView ? sendMessage() : null
                "
                rows="1"
              ></textarea>
            </div>
            @if (!showFabActions) {
              @if (!chatMessage.trim()) {
                <span
                  (click)="audioBtnPressed($event)"
                  class="bg-success rounded-5 p-2"
                >
                  <i class="fa-solid fa-microphone fa-2x text-white"></i>
                </span>
              } @else if (!sendBtnPressed) {
                <span (click)="sendMessage()">
                  <i class="fa fa-paper-plane fa-2x text-success"></i>
                </span>
              }
            }
          </div>
          <div id="chatBottom">
            <!--empty div to get the scroll to bottom-->
          </div>
        </div>
      }
    </div>
  }
  @if (gtNotificationsList?.length) {
    <div class="chat-container col col-lg-8 p-0">
      <div
        class="d-flex align-items-center gap-3 p-2 pt-3 border-bottom bg-body-tertiary"
      >
        @if (!largeView) {
          <div>
            <span (click)="gtNotificationsList = []"
              ><i class="fa-solid fa-arrow-left md-font-size text-secondary"></i
            ></span>
          </div>
        }
        <div class="d-flex gap-2 align-items-center w-100">
          <div class="flex-grow-1 d-flex gap-2 align-items-center">
            <div class="profile-image-circle">
              {{ "Guard Tracker" | misc: "getInitials" }}
            </div>

            <div class="d-flex align-items-center gap-3">
              System Notifications
            </div>
          </div>
          <div>
            <button
              class="btn btn-outline-danger btn-sm"
              (click)="clearNotifications()"
            >
              Clear ALl
            </button>
          </div>
        </div>
      </div>

      <div
        (scroll)="onNotificationWindowScroll($event)"
        #content
        [ngClass]="
          gtNotificationsList?.length > 7
            ? 'chat-content'
            : 'chat-content-small'
        "
      >
        @for (
          notification of gtNotificationsList;
          track notification?.id;
          let l = $last;
          let index = $index
        ) {
          @if (index === anchorIndex) {
            <!-- used for iphones on scrolling up-->
            <div #anchor></div>
          }
          @if (
            index === 0 ||
            (gtNotificationsList[index - 1].created_at
              | misc: "eventDateGrouping") !==
              (notification?.created_at | misc: "eventDateGrouping")
          ) {
            <!--date change/grouping at the center of chat -->
            <div class="p-2 text-center fw-semibold text-secondary small">
              {{ notification?.created_at | misc: "eventDateGrouping" }}
            </div>
          }
          <div class="mt-1 d-flex">
            <div
              [ngClass]="
                [
                  'job',
                  'feedback',
                  'incident',
                  'user_license',
                  'company_license',
                  'patrol_job',
                  'run_sheet',
                  'registration',
                  'hol_alert',
                  'geo_fence_alert',
                  'welfare_check',
                ].includes(notification?.event_type)
                  ? 'cursor-pointer hover'
                  : ''
              "
              class="receiver-container"
              (click)="
                redirectNotification(notification);
                $event.stopImmediatePropagation()
              "
            >
              <div class="d-inline gap-2">
                <div class="d-flex align-items-center">
                  <div
                    class="receiver-card"
                    [id]="'notification-' + notification?.id"
                  >
                    <div class="d-flex gap-2 mb-1">
                      <div
                        class="flex-grow-1 justify-content-center fw-semibold"
                      >
                        {{ notification?.notification_title }}
                      </div>
                      <div>
                        <span
                          (click)="
                            deleteNotification(notification);
                            $event.stopImmediatePropagation()
                          "
                        >
                          <i
                            class="fa-solid fa-circle-minus text-danger md-font-size"
                          ></i>
                        </span>
                      </div>
                    </div>

                    <div class="p-2 gt-multi-line mb-2">
                      @for (
                        part of notification?.notification_msg
                          | misc: "generateLinks";
                        track part
                      ) {
                        @if (part?.url) {
                          <a
                            [href]="part?.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ part?.url }}</a
                          >
                        } @else {
                          {{ part }}
                        }
                      }
                    </div>

                    <div
                      class="d-flex timestamp justify-content-end gap-1 opacity-75 text-dark"
                    >
                      {{ notification?.created_at | customDate: "HH:mm" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (l) {
            <div id="lastItem" class="pb-5"></div>
          }
        }
      </div>
    </div>
  }
</div>

<ng-template
  #forwardMessageTemplateRef
  let-data
  let-forwardMessageTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Forward Message
      <span class="float-end" (click)="forwardMessageTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <!-- <div class="mb-1">
                                  <gtapp-auto-complete
                                    [data]="assigneeSearchList"
                                    placeHolder="Guard Name"
                                    searchKeyword="full_name"
                                    [itemTemplate]="assigneeListTemplate"
                                    (inputChanged)="searchAssignee($event)"
        (selected)="
          getUserMessage($event);
          forwardMessageTemplateRef.close();
          newChat = true;
          messageList = []
        "
                                    >
                                  </gtapp-auto-complete>
                                </div>

                                <ng-template #assigneeListTemplate let-item>
                                  <div>
                                    {{ item?.full_name }}
                                  </div>
                                </ng-template> -->

    <table class="table mb-3">
      <tbody>
        @for (assignee of forwardMessageUserListData; track assignee) {
          <tr class="pointer">
            <td>
              <div class="d-flex">
                <div>
                  <div class="form-floating">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="assignee?.selected"
                      (change)="selectDelselectAssignee($event, assignee)"
                    />
                  </div>
                </div>
                <div class="flex-grow-1 ms-2">
                  {{ assignee?.user_name }}
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="forwardMessageTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-success btn-lg w-100"
          [disabled]="!selectedForwardMessageUsers?.length"
          (click)="
            manageMessage('forwardMessage', data);
            forwardMessageTemplateRef.close()
          "
        >
          Forward
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #jobSearchTemplate let-jobSearchTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Reference Job
      <span class="float-end" (click)="jobSearchTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="input-group my-2">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            placeholder="Search Jobs"
            (input)="searchJobs($event)"
            [(ngModel)]="jobFilterValue"
          />
          <label>Search Jobs</label>
        </div>

        @if (jobFilterValue) {
          <span
            class="input-group-text"
            (click)="searchJobs({ target: { value: '' } })"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      @if (filteredJobList?.length) {
        <div class="overflow-45vh">
          <div class="small">
            @for (job of filteredJobList; track job) {
              <div>
                <div
                  class="border mb-2 rounded gt-card d-flex gap-3 cursor-pointer"
                  (click)="
                    selectedJob = job;
                    jobSearchTemplate.close();
                    scrollToBottom()
                  "
                >
                  @if (job?.schedule_details?.start_time) {
                    <div class="fw-semibold">
                      {{
                        job?.schedule_details?.start_time
                          | misc: "formatStartEndTime"
                      }}
                    </div>
                  }
                  <div class="flex-grow-1">
                    <div class="d-flex">
                      <div class="fw-semibold flex-grow-1">
                        <span
                          [ngClass]="
                            job?.job_type_key == 0 ? 'text-danger' : ''
                          "
                        >
                          {{
                            job?.job_type_key == 4
                              ? "Checkpoint Patrol"
                              : job?.job_type_name
                          }}
                          @if (job?.response_type_name) {
                            <span> - {{ job.response_type_name }} </span>
                          }
                        </span>
                      </div>
                      @if (job?.status_name) {
                        <div>
                          {{ job?.status_name }}
                        </div>
                      }
                      @if (
                        job?.checkpoints && job?.checkpoints_remaining == 0
                      ) {
                        <div>
                          <span class="bg-success text-white"> Complete </span>
                        </div>
                      }
                    </div>
                    <div>
                      <span>
                        {{ job?.site_name }}
                      </span>
                      @if (job?.company_name) {
                        <span>[{{ job?.company_name }}]</span>
                      }
                    </div>
                    @if (job?.checkpoints) {
                      <div>
                        @if (job?.checkpoints_remaining) {
                          Scanned:
                          {{ job?.checkpoints - job?.checkpoints_remaining }} of
                          {{ job?.checkpoints }}
                        }
                      </div>
                    }
                    <div>
                      {{ job?.site_address }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #modifyGroupTemplate let-modifyGroupTemplateRef="dialogRef">
  <div class="card dialog-box p-1 small">
    <div class="card-header">
      {{
        selectedGroupDetails?.id
          ? selectedGroupDetails?.editData
            ? "Update Group"
            : selectedGroupDetails.group_name
          : "New Group"
      }}
      <span class="float-end" (click)="modifyGroupTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (selectedGroupDetails?.editData || !selectedGroupDetails?.id) {
      <div>
        @if (!selectedGroupDetails?.id) {
          <div class="input-group mb-3">
            <div class="form-floating">
              <input
                class="form-control"
                id="groupName"
                type="text"
                [maxlength]="128"
                placeholder="Group Name"
                [(ngModel)]="selectedGroupDetails.group_name"
                autocomplete="off"
              />
              <label for="groupName">Group Name</label>
            </div>
            @if (selectedGroupDetails?.group_name) {
              <span
                class="input-group-text"
                (click)="
                  clearAndFocusTextBox('groupName');
                  selectedGroupDetails.message = ''
                "
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
        }
        <div class="fs-6 fw-semibold">Select Group Members</div>
        <div class="overflow-45vh">
          <table class="table mb-3">
            <tbody>
              @for (assignee of assigneeList; track assignee) {
                <tr class="pointer">
                  <td>
                    <div class="d-flex py-2">
                      <div>
                        <div class="form-floating">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [checked]="assignee?.selected"
                            [disabled]="
                              assignee?.additional_info?.is_group_owner
                            "
                            (change)="addRemoveGroupMembers($event, assignee)"
                          />
                        </div>
                      </div>
                      <div class="flex-grow-1 ms-2">
                        {{ assignee?.user_name }}
                        @if (assignee?.additional_info?.is_group_owner) {
                          <span class="text-secondary fw-semibold"
                            >[Owner]</span
                          >
                        }
                      </div>
                      @if (assignee?.selected) {
                        <div>
                          <div class="form-floating">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [disabled]="
                                assignee?.additional_info?.is_group_owner
                              "
                              [checked]="
                                assignee?.additional_info?.is_group_admin
                              "
                              (change)="
                                groupMemeberPrivilages(
                                  $event,
                                  assignee,
                                  'is_group_admin'
                                )
                              "
                            />
                            Make Group Admin
                          </div>
                        </div>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex gap-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="modifyGroupTemplateRef.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              !selectedGroupDetails?.group_name ||
              selectedGroupMembers?.length < 3
            "
            (click)="
              manageChatGroup(
                selectedGroupDetails?.id ? 'updateGroup' : 'createGroup',
                selectedGroupDetails
              )
            "
          >
            {{ selectedGroupDetails?.id ? "Update" : "Create" }}
          </button>
        </div>
      </div>
    } @else {
      <div>
        <div class="d-flex align-items-center gap-2">
          <div class="input-group mb-3">
            <div class="form-floating">
              <input
                class="form-control"
                id="groupName"
                type="text"
                [maxlength]="128"
                placeholder="Group Name"
                [(ngModel)]="selectedGroupDetails.group_name"
                [disabled]="!hasGroupAdminPrivilage"
                autocomplete="off"
              />
              <label for="groupName">Group Name</label>
            </div>
            @if (selectedGroupDetails?.group_name && hasGroupAdminPrivilage) {
              <span
                class="input-group-text"
                (click)="
                  clearAndFocusTextBox('groupName');
                  selectedGroupDetails.group_name = ''
                "
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          @if (
            selectedGroupDetailsBackup?.group_name !==
              selectedGroupDetails.group_name && selectedGroupDetails.group_name
          ) {
            <span
              (click)="
                manageChatGroup(
                  selectedGroupDetails?.id ? 'updateGroup' : 'createGroup',
                  selectedGroupDetails
                )
              "
            >
              <i class="fa-solid fa-check fa-2x text-success"></i>
            </span>
          }
        </div>
        @if (hasGroupAdminPrivilage) {
          <div
            role="button"
            class="d-flex align-items-center rounded p-2 mb-1 gap-2 fw-semibold"
            (click)="selectedGroupDetails.editData = true"
            role="button"
          >
            <div class="profile-image-circle bg-primary text-light border-0">
              <i class="fa-solid fa-user-plus fs-6"></i>
            </div>
            Add/Remove Users
          </div>
        }
        @for (user of assigneeList; track user) {
          <div>
            @if (user?.selected) {
              <div
                role="button"
                class="d-flex align-items-center rounded p-2 mb-1 gap-2"
                (click)="
                  resetPagesAndGetData(user); modifyGroupTemplateRef.close()
                "
              >
                <div class="profile-image-circle">
                  @if (user?.profile_image_url) {
                    <img
                      alt="Profile Image"
                      class="cursor-pointer"
                      [src]="user?.profile_image_url"
                      (click)="
                        onProfileImageClick(user?.profile_image_url);
                        $event.stopImmediatePropagation()
                      "
                    />
                  } @else {
                    {{ user?.user_name | misc: "getInitials" }}
                  }
                </div>
                <div
                  class="flex-grow-1 d-flex align-items-center gap-3 justify-content-between"
                >
                  <div>
                    {{ user?.user_name }}
                  </div>
                  @if (user?.additional_info?.is_group_admin) {
                    <div
                      class="small-font px-2 py-1 rounded text-center border-success text-white bg-success"
                    >
                      {{
                        user?.additional_info?.is_group_owner
                          ? "Group Owner"
                          : "Group Admin"
                      }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template
  #editMessageTemplateRef
  let-editMessageTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      Edit Message
      <span class="float-end" (click)="editMessageTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="data.message"
          id="updateCommentBox"
        ></textarea>
        @if (data?.message) {
          <span
            class="input-group-text"
            (click)="
              clearAndFocusTextBox('updateCommentBox'); data.message = ''
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="editMessageTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="!data?.message || data?.oldValue === data?.message"
            (click)="
              manageMessage('editComment', data); editMessageTemplateRef.close()
            "
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #messageFileTempalte let-message="value">
  <div class="media-view mb-2" (click)="$event.stopImmediatePropagation()">
    @if ([".mp4", ".mov", ".webm", ".mkv"].includes(message?.file_extension)) {
      <video controls muted class="chat-media">
        <source src="{{ message?.file }}" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3"].includes(message?.file_extension)) {
      <audio
        src="{{ message?.file }}"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        (click)="onOpenImage($event, message)"
        src="{{ message?.file }}"
        class="chat-media"
      />
    }
  </div>
</ng-template>
